module.exports = "\n<div mat-dialog-content>\n  <p>Aguarde o carregamento</p>\n  <mat-progress-bar mode=\"buffer\"></mat-progress-bar>\n</div>"